/* ==========================================================================
   CREATIVE DETONATOR - Chamber Controller
   Detonation chamber toggle controls for method pages
   Location: frontend/js/method/chamber.js
   ========================================================================== */

const ChamberController = {
  controls: [],
  activeCount: 0,

  init() {
    this.controls = document.querySelectorAll('.control-module');
    this.statusSegments = document.querySelectorAll('.status-segment');
    this.statusText = document.querySelector('.status-text');
    this.statusCount = document.querySelector('.status-count');
    this.statusBar = document.querySelector('.chamber-status');

    this.bindEvents();
    this.updateStatus();
  },

  bindEvents() {
    this.controls.forEach((control, index) => {
      const toggle = control.querySelector('.toggle');
      const label = control.querySelector('.toggle-label');

      if (toggle) {
        toggle.addEventListener('click', (e) => {
          e.stopPropagation();
          this.toggleControl(control, toggle, label);
        });
      }
    });
  },

  toggleControl(control, toggle, label) {
    const isActive = toggle.classList.contains('active');

    if (isActive) {
      toggle.classList.remove('active');
      label.textContent = 'OFF';
      control.classList.remove('active');
    } else {
      toggle.classList.add('active');
      label.textContent = 'ON';
      control.classList.add('active');
      this.playClickSound();
    }

    this.updateStatus();
  },

  updateStatus() {
    const activeToggles = document.querySelectorAll('.toggle.active');
    this.activeCount = activeToggles.length;

    // Update status bar segments
    this.statusSegments.forEach((segment, index) => {
      if (index < this.activeCount) {
        segment.classList.add('filled');
      } else {
        segment.classList.remove('filled');
      }
    });

    // Update status text
    if (this.statusText) {
      if (this.activeCount === 7) {
        this.statusText.textContent = 'CHAMBER ARMED';
      } else {
        this.statusText.textContent = 'CONTROLS ACTIVE';
      }
    }

    if (this.statusCount) {
      this.statusCount.textContent = `${this.activeCount}/7`;
    }

    // Check for complete
    if (this.activeCount === 7) {
      this.statusBar.classList.add('complete');
      this.playSuccessSound();
    } else {
      this.statusBar.classList.remove('complete');
    }
  },

  playClickSound() {
    try {
      const ctx = new (window.AudioContext || window.webkitAudioContext)();
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.connect(gain);
      gain.connect(ctx.destination);
      osc.frequency.value = 800;
      osc.type = 'square';
      gain.gain.value = 0.1;
      osc.start();
      gain.gain.exponentialRampToValueAtTime(0.01, ctx.currentTime + 0.1);
      osc.stop(ctx.currentTime + 0.1);
    } catch(e) {}
  },

  playSuccessSound() {
    try {
      const ctx = new (window.AudioContext || window.webkitAudioContext)();
      const notes = [523, 659, 784]; // C5, E5, G5
      notes.forEach((freq, i) => {
        const osc = ctx.createOscillator();
        const gain = ctx.createGain();
        osc.connect(gain);
        gain.connect(ctx.destination);
        osc.frequency.value = freq;
        osc.type = 'square';
        gain.gain.value = 0.1;
        osc.start(ctx.currentTime + i * 0.1);
        gain.gain.exponentialRampToValueAtTime(0.01, ctx.currentTime + i * 0.1 + 0.2);
        osc.stop(ctx.currentTime + i * 0.1 + 0.2);
      });
    } catch(e) {}
  }
};

// Auto-init when DOM ready and page type matches
document.addEventListener('DOMContentLoaded', () => {
  if (document.body.dataset.methodPage === 'chamber') {
    ChamberController.init();
  }
});

// Export for external use
window.ChamberController = ChamberController;
